import { theme } from '@nobia/zeus-components/lib/styled'

export default {
  body: {
    bgColor: '#F2E9DB',
    color: '#31261D',
    padding: '16px',
    tabletWidth: '680px',
    desktopWidth: '1024px',
    marginDesktop: '70px',
  },
  header: {
    maxWidth: '985px',
    margin: '30px 80px 0 80px',
  },
  section: {
    bgColor: '#E4D4C4',
    color: '#31261D',
    fontSize: '26px',
    fontWeight: '500',
  },
  iconWrapper: {
    bgColor: '#fbf9f6',
  },
  banner: {
    color: '#FBF9F6',
    bgColor: '#31261d',
  },
  tooltip: {
    color: '#FBF9F6',
    bgColor: '#31261D',
  },
  card: {
    border: {
      selected: '#31261D',
      default: '#E4D5C4',
    },
  },
  font: {
    headings: {
      fontFamily: 'Reckless Neue, serif',
      fontWeight: '350',
      title: {
        fontSizeSm: '36px',
        lineHeightSm: '40px',
        fontSizeLg: '66px',
        lineHeightLg: '71px',
      },
    },
    preamble: {
      fontFamily: 'Lausanne, serif',
      fontWeight: '250',
      lineHeight: '36px',
    },
    paragraph: {
      fontFamily: 'Lausanne, serif',
      lineHeight: '24px',
    },
  },
  button: {
    fontWeight: '350',
    padding: '12px 30px',
  },
  costSummary: {
    totalCost: {
      fontSize: '18px',
    },
    link: {
      fontSize: '13px',
    },
  },
  email: {
    error: {
      color: '#872E2E',
    },
    bgColor: '#F2E9DB',
    label: {
      fontSize: '16px',
    },
    input: {
      bgColor: '#fbf9f6',
      border: '1px solid #C3B5A7',
    },
    wrapper: {
      minWidth: '400px',
    },
    padding: '30px',
  },
  badaPromo: {
    image: {
      maxWidth: '460px',
    },
    wrapper: {
      padding: '80px 96px 30px',
    },
  },
  summary: {
    paddingRight: '50px',
    mobile: {
      paddingRight: '50px',
    },
  },
  input: {
    mobile: {
      marginLeft: '20px',
    },
    select: {
      bgColor: '#fbf9f6',
    },
    borderColor: '#C3B5A7',
  },
  colors: {
    primary: '#31261D',
    toneA: '#FAF5F2',
    banner: '#31261D',
    button: '#1e44cb',
    badaBlock: theme('colors.white'),
  },
}
